import { ref, computed } from 'vue'
//import constants from "@/assets/constants.js";
import { dataProvider } from '@/api/dataProvider';
import { store } from "@/store/store.js";

const NONE_OPTION = { ID: -1, Name: 'None' };

// Full list of agents available to the portal
const aIAgentOptions = ref([NONE_OPTION]);
// The agent currently persisted against the load (-1 = none saved).
// Only changes when load data is fetched from the API, never from unsaved UI edits.
const assignedAIAgentTypeID = ref(-1);

const aIAgentEnabled = computed(() => aIAgentOptions.value.some(x => x.ID != -1));
const aIAgentTypeID = ref(-1);
const aIAgentData = ref(null);

// Filter if the load has an agent assigned
const aIAgents = computed(() =>
  assignedAIAgentTypeID.value !== -1
    ? aIAgentOptions.value.filter(x => x.ID == assignedAIAgentTypeID.value)
    : aIAgentOptions.value
);

const aIAgentLoading = ref(false);

async function getAIAgentOptions() {
  aIAgentLoading.value = true;
  let options = await dataProvider.getPortalAIAgents(store.state.login.portalID);
  aIAgentOptions.value = [NONE_OPTION, ...options];
  let defaultAgent = aIAgentOptions.value.find(x => x.Default)
  if(defaultAgent !== undefined) {
    aIAgentTypeID.value = defaultAgent.ID;
  }
  aIAgentLoading.value = false;
}

async function getLoadAIAgentData(loadID) {
  aIAgentLoading.value = true;
  let data = await dataProvider.getLoadAIAgent(loadID);
  // GetLoadAgent returns Data = null when Autofill is 0 or no posting row exists.
  if(data) {
    aIAgentTypeID.value = data.typeID;
    aIAgentData.value = data.data;
    assignedAIAgentTypeID.value = data.typeID;
  } else {
    // This is only reached for a posted load, so "no agent record" means the user
    // explicitly saved the load with "None". Populate dropdown with None rather than the portal
    // default so unchecking and rechecking Post Load without saving doesn't
    // silently re-select an agent they already opted out of.
    resetLoadAIAgent(-1);
  }
  aIAgentLoading.value = false;
}

function resetLoadAIAgent(selectedTypeID) {
  assignedAIAgentTypeID.value = -1;
  aIAgentData.value = null;
  aIAgentTypeID.value = selectedTypeID;
}

// Call when the load has no AI Agent assigned and no explicit choice on record -
// e.g. Post Load was unchecked and saved. Falls back to the portal's default agent.
function clearLoadAIAgent() {
  let defaultAgent = aIAgentOptions.value.find(x => x.Default);
  resetLoadAIAgent(defaultAgent !== undefined ? defaultAgent.ID : -1);
}

function setLoadAIAgentData(data) {
  aIAgentData.value = data;
}

export function useAIAgent() {

  return {
    aIAgentEnabled,
    aIAgentTypeID,
    aIAgentData,
    aIAgents,
    aIAgentLoading,
    getAIAgentOptions,
    getLoadAIAgentData,
    clearLoadAIAgent,
    setLoadAIAgentData
  }
}